var exports = {
  "kL": "xfd349460--f80447--container",
  "su": "xfd349460--f80447--icon-wrapper",
  "DD": "xfd349460--f80447--title",
  "VA": "xfd349460--f80447--subtitle",
};

module.exports = exports;
